"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComparisonBarActions = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _Icon = require("b2b-components/theme/components/Icon");
var _key = require("b2b-components/utils/key");
require("./ComparisonBarActions.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ComparisonBarActions = function ComparisonBarActions(_ref) {
  var isVisible = _ref.isVisible,
    actions = _ref.actions;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isMenuOpen = _useState2[0],
    setIsMenuOpen = _useState2[1];
  var handleMenuToggle = function handleMenuToggle() {
    setIsMenuOpen(function (previousValue) {
      return !previousValue;
    });
  };
  (0, _react.useEffect)(function () {
    if (!isVisible) {
      setIsMenuOpen(false);
    }
  }, [isVisible]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-ComparisonBarActions"
  }, /*#__PURE__*/_react["default"].createElement(_ButtonIcon.ButtonIcon, {
    icon: _ButtonIcon.BUTTON_ICON_ICON_NAME.dots,
    size: _ButtonIcon.BUTTON_ICON_SIZE.medium,
    styleType: _Button.Button.config.styleType.negative,
    onClick: handleMenuToggle
  }), isMenuOpen && /*#__PURE__*/_react["default"].createElement("ul", {
    className: "cds-ComparisonBarActions-Menu"
  }, actions.map(function (action, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: (0, _key.createKey)(action.label, index),
      className: "cds-ComparisonBarAction"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      onClick: action.onClick,
      className: "cds-ComparisonBarAction-IconBox"
    }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      name: action.icon,
      size: _Icon.Icon.config.size.small,
      className: "cds-ComparisonBarAction-Icon"
    })), /*#__PURE__*/_react["default"].createElement("span", {
      onClick: action.onClick,
      className: "cds-ComparisonBarAction-Label"
    }, action.label), /*#__PURE__*/_react["default"].createElement("div", null), /*#__PURE__*/_react["default"].createElement("div", {
      className: "cds-ComparisonBarAction-Description"
    }, action.description));
  })));
};
exports.ComparisonBarActions = ComparisonBarActions;